import { useSession } from "@/context/SessionContext";

const normalizedProductId = (value) => String(value ?? "").trim().replace(/^0+(?=\d)/, "");

export default function FreeDeliveryTicker({ speed = "slow", className = "" }) {
  const { ready, countryId, freightProductId, products, productTexts } = useSession();
  const productId = normalizedProductId(freightProductId);
  const deliveryProduct = (products || []).find((product) => {
    const productCountry = product.country_id || product.CountryId;
    return normalizedProductId(product.product_id || product.ProductId) === productId && (!productCountry || productCountry === countryId);
  });
  const deliveryProductId = deliveryProduct?.product_id || deliveryProduct?.ProductId;
  const textRow = deliveryProductId ? productTexts?.[String(deliveryProductId)] : null;
  const message = String(textRow?.longDescription || textRow?.long_description || "").trim();

  if (!ready || !productId || !deliveryProduct || !message) return null;

  return (
    <div data-testid={`free-delivery-ticker-${speed}`} className={`free-delivery-ticker free-delivery-ticker-${speed} ${className}`}>
      <div className="free-delivery-ticker-track">
        <img
          src="/assets/delivery-truck.webp"
          width="105"
          height="71"
          data-testid="free-delivery-truck"
          alt=""
          className="free-delivery-truck"
        />
        <span data-testid="free-delivery-text" className="font-display text-sm sm:text-base font-bold uppercase tracking-widest text-slate-100">{message}</span>
      </div>
    </div>
  );
}